import { memo, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { BodyCopy } from "../../../components/BodyCopy";
import {
  Button,
  Layout,
  PageTitle,
} from "lola-framework-ui-test";
import { AuraLayout } from "../../../components/AuraLayout";
import { ErrorAlertIcon as ErrorIcon } from "../../../assets/icons";
import { FlowHeroMark } from "../../../components/FlowHeroMark";
import { useStore } from "../../../store/globalState";
import { useExitToPartnerOrLanding } from "../../../hooks/useExitToPartnerOrLanding";
import { getEvents, safeCapture } from "../../../analytics";
import { ScrollFadeIndicator } from "../../../components/ScrollFadeIndicator";

/**
 * Shown when the user's session expired (link expired or not found). Offers a
 * button to return to the partner app via the callback URL, or landing if unset.
 */
export const SessionExpiredPage = memo(() => {
  const { t } = useTranslation();
  const { theme } = useStore();
  const { exitToPartnerOrLanding, canExitToPartner } = useExitToPartnerOrLanding();

  const colorConfig = theme.errorView;
  const { backgroundBtn, textColorBtn, title, bodyCopy, iconColors, backgroundIcon } =
    colorConfig;

  useEffect(() => {
    safeCapture(getEvents().SESSION_EXPIRED);
  }, []);

  return (
    <AuraLayout colorConfig={colorConfig} className="flow-landing-page">
      <Layout.Content className="landing-section flow-hero-section">
        <ScrollFadeIndicator color={colorConfig.bodyCopy} />

        <section className="flow-hero">

          <FlowHeroMark backgroundIcon={backgroundIcon}>

            <ErrorIcon size={60} colors={iconColors} />

          </FlowHeroMark>
        <section className="landing-container">
          <PageTitle
            highlight={t("error.sessionExpired")}
            highlightColor={title}
            secudnary=""
            secudnaryColor={title}
          />
          <BodyCopy textColor={bodyCopy}>
            {t("error.sessionExpiredMessage")}
          </BodyCopy>
        </section>
        </section>
      </Layout.Content>
      {canExitToPartner && (
        <Layout.Footer>
          <section className="footer-section">
            <Button
              size="large"
              background={backgroundBtn}
              color={textColorBtn}
              onClick={() => {
                safeCapture(getEvents().EXIT_CLICK, { screen: "session_expired" });
                exitToPartnerOrLanding();
              }}
            >
              {t("error.returnToApp")}
            </Button>
          </section>
        </Layout.Footer>
      )}
    </AuraLayout>
  );
});
